module.exports = __webpack_public_path__ + "img/6.e7c82f65.png";